import styled from 'styled-components';

import SvgIcon from '~src/shared/SvgIcon';
import { media } from '~src/styles/media-templates';

export const ItemTypeCard = styled.div`
  height: 100%;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${({ theme }) => theme.white.a10};
  padding: 45px 30px 30px;
  box-shadow: 0 4px 14px 0 rgba(0, 0, 0, 0.03);
  border-radius: 5px;
  border: solid 1px ${({ theme }) => theme.black.a1};
  transition: all 0.2s ease-in;
  opacity: 0.5;

  &:focus,
  &:hover,
  &:active,
  &.selected {
    box-shadow: 0 14px 40px 0 rgba(78, 84, 107, 0.4);
    border: solid 1px ${({ theme }) => theme.baseBlue.a10};
    opacity: 1;
  }

  input[type='radio'] {
    margin: 0;
    padding: 0;
    opacity: 0;
  }

  ${media.tablet`
    padding: 15px;
  `}
`;

export const ItemTypeIcon = styled(SvgIcon)<{ viewBoxWidth?: number }>`
  cursor: pointer;
  width: 60px;
  height: 60px;
  color: ${({ theme }) => theme.baseBlue.a10};
`;

export const ItemTypeName = styled.div`
  font-size: 1.4rem;
  letter-spacing: 0.3px;
  text-align: center;
  color: ${({ theme }) => theme.baseBlue.a10};
  margin-top: 10px;
  font-weight: 600;
`;

export const ItemTypeDescription = styled.div`
  font-size: 1rem;
  line-height: 1.733rem;
  text-align: center;
  color: ${({ theme }) => theme.baseBlue.a6};
  margin-top: 10px;
  width: 300px;
  max-width: 100%;
`;
